import { c as _c } from "react/compiler-runtime";
import { postOrgAuthMagicLinkMutation, postOrgAuthSamlSsoMutation } from '@onefootprint/fetch-dashboard';
import { useRequestErrorToast } from '@onefootprint/hooks';
import { Button, Form } from '@onefootprint/ui';
import { useMutation } from '@tanstack/react-query';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import getAuthRedirectUrl from '../../get-auth-redirect-url';
import useResetOnPageRestore from '../use-reset-on-page-restore';
type FormData = {
  email: string;
};
const EmailForm = () => {
  const $ = _c(39);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "email"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("authentication", t0);
  const router = useRouter();
  const showRequestErrorToast = useRequestErrorToast();
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = postOrgAuthMagicLinkMutation();
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== showRequestErrorToast) {
    t2 = {
      ...t1,
      onError: showRequestErrorToast
    };
    $[2] = showRequestErrorToast;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const mutateLoginEmail = useMutation(t2);
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = postOrgAuthSamlSsoMutation();
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== showRequestErrorToast) {
    t4 = {
      ...t3,
      onError: showRequestErrorToast
    };
    $[5] = showRequestErrorToast;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const mutateSamlSso = useMutation(t4);
  const methods = useForm();
  const [redirecting, setRedirecting] = useState(false);
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setRedirecting(false);
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  useResetOnPageRestore(t5);
  const isPending = mutateSamlSso.isPending || mutateLoginEmail.isPending || redirecting;
  let t6;
  if ($[8] !== mutateLoginEmail || $[9] !== mutateSamlSso || $[10] !== router) {
    t6 = t7 => {
      const {
        email
      } = t7;
      mutateSamlSso.mutate({
        body: {
          emailAddress: email,
          redirectUrl: getAuthRedirectUrl()
        }
      }, {
        onSuccess(data) {
          if (data.samlSsoUrl) {
            setRedirecting(true);
            window.location.href = data.samlSsoUrl;
            return;
          }
          mutateLoginEmail.mutate({
            body: {
              emailAddress: email,
              redirectUrl: getAuthRedirectUrl()
            }
          }, {
            onSuccess: () => router.push({
              pathname: "/authentication/link-sent",
              query: {
                email
              }
            })
          });
        }
      });
    };
    $[8] = mutateLoginEmail;
    $[9] = mutateSamlSso;
    $[10] = router;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const onSubmit = t6;
  let t7;
  if ($[12] !== methods || $[13] !== onSubmit) {
    t7 = methods.handleSubmit(onSubmit);
    $[12] = methods;
    $[13] = onSubmit;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t) {
    t8 = t(_temp);
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t) {
    t9 = t(_temp2);
    $[17] = t;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t) {
    t10 = t(_temp3);
    $[19] = t;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10) {
    t11 = {
      required: t10
    };
    $[21] = t10;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11 || $[24] !== t8 || $[25] !== t9) {
    t12 = <Form.Input name="email" label={t8} autoComplete="email" placeholder={t9} type="email" rules={t11} />;
    $[23] = t11;
    $[24] = t8;
    $[25] = t9;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t) {
    t13 = t(_temp4);
    $[27] = t;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== isPending || $[30] !== t13) {
    t14 = <Button fullWidth={true} loading={isPending} disabled={isPending} size="large" type="submit">{t13}</Button>;
    $[29] = isPending;
    $[30] = t13;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t12 || $[33] !== t14 || $[34] !== t7) {
    t15 = <form className="flex flex-col gap-4" onSubmit={t7}>{t12}{t14}</form>;
    $[32] = t12;
    $[33] = t14;
    $[34] = t7;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== methods || $[37] !== t15) {
    t16 = <FormProvider {...methods}>{t15}</FormProvider>;
    $[36] = methods;
    $[37] = t15;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  return t16;
};
export default EmailForm;
function _temp($) {
  return $.form.email.label;
}
function _temp2($_0) {
  return $_0.form.email.placeholder;
}
function _temp3($_1) {
  return $_1.form.email.errors.required;
}
function _temp4($_2) {
  return $_2.cta;
}